export const colorOptions = [
  { name: 'Salmon', value: '#FA8072' },
  { name: 'Crimson', value: '#DC143C' },
  { name: 'Red', value: '#FF0000' },
  { name: 'DarkRed', value: '#8B0000' },
  { name: 'Pink', value: '#FFC0CB' },
  { name: 'LightPink', value: '#FFB6C1' },
  { name: 'HotPink', value: '#FF69B4' },
  { name: 'DeepPink', value: '#FF1493' },
  { name: 'OrangeRed', value: '#FF4500' },
  { name: 'DarkOrange', value: '#FF8C00' },
  { name: 'Orange', value: '#FFA500' },
  { name: 'Gold', value: '#FFD700' },
  { name: 'Yellow', value: '#FFFF00' },
  { name: 'LemonChiffon', value: '#FFFACD' },
  { name: 'Violet', value: '#EE82EE' },
  { name: 'Magenta', value: '#FF00FF' },
  { name: 'BlueViolet', value: '#8A2BE2' },
  { name: 'DarkViolet', value: '#9400D3' },
  { name: 'DarkMagenta', value: '#8B008B' },
  { name: 'Purple', value: '#800080' },
  { name: 'Indigo', value: '#4B0082' },
  { name: 'GreenYellow', value: '#ADFF2F' },
  { name: 'Lime', value: '#00FF00' },
  { name: 'LimeGreen', value: '#32CD32' },
  { name: 'ForestGreen', value: '#228B22' },
  { name: 'Green', value: '#008000' },
  { name: 'Olive', value: '#808000' },
  { name: 'DarkOliveGreen', value: '#556B2F' },
  { name: 'Teal', value: '#008080' },
  { name: 'DarkTurquoise', value: '#00CED1' },
  { name: 'SkyBlue', value: '#87CEEB' },
  { name: 'DeepSkyBlue', value: '#00BFFF' },
  { name: 'DodgerBlue', value: '#1E90FF' },
  { name: 'CornflowerBlue', value: '#6495ED' },
  { name: 'RoyalBlue', value: '#4169E1' },
  { name: 'Blue', value: '#0000FF' },
  { name: 'MediumBlue', value: '#0000CD' },
  { name: 'DarkBlue', value: '#00008B' },
  { name: 'Navy', value: '#000080' },
  { name: 'MidnightBlue', value: '#191970' },
  { name: 'Wheat', value: '#F5DEB3' },
  { name: 'BurlyWood', value: '#DEB887' },
  { name: 'Tan', value: '#D2B48C' },
  { name: 'RosyBrown', value: '#BC8F8F' },
  { name: 'SandyBrown', value: '#F4A460' },
  { name: 'SaddleBrown', value: '#8B4513' },
  { name: 'Sienna', value: '#A0522D' },
  { name: 'Brown', value: '#A52A2A' },
  { name: 'Maroon', value: '#800000' },
  { name: 'White', value: '#FFFFFF' },
  { name: 'Beige', value: '#F5F5DC' },
  { name: 'Silver', value: '#C0C0C0' },
  { name: 'DarkGray', value: '#A9A9A9' },
  { name: 'Gray', value: '#808080' },
  { name: 'DimGray', value: '#696969' },
  { name: 'Black', value: '#000000' }
];

export const clothesSizeOptions = [
  { name: 'xs', value: 'xs' },
  { name: 's', value: 's' },
  { name: 'm', value: 'm' },
  { name: 'l', value: 'l' },
  { name: 'xl', value: 'xl' },
  { name: 'xxl', value: 'xxl' }
];

export const shoesUsSizeOptions = [
  '6', '6.5', '7', '7.5', '8', '8.5', '9', '9.5', '10', '10.5',
  '11', '11.5', '12', '12.5', '13', '13.5', '14', '14.5', '15', '15.5', '16'
];
